import React from "react";
import { useNavigate } from "react-router-dom";
import { Bot, BarChart2, FileDown, GraduationCap, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "components/ui/card";
import { Button } from "components/ui/button";
import { Badge } from "components/ui/badge";
import { QUICK_GUIDES } from "../../helpContent";

const iconMap = {
  assistant: Bot,
  benchmarking: BarChart2,
  library: FileDown,
  entities: GraduationCap,
};

const QuickGuides = () => {
  const navigate = useNavigate();

  return (
    <section id="quick-guides" className="space-y-4">
      <div>
        <h2 className="text-xl font-bold tracking-tight text-gray-900">Feature Guides & Direct Shortcuts</h2>
        <p className="text-sm text-gray-500">
          Essential tools to accelerate your literature evaluation and institutional benchmark workflows.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {QUICK_GUIDES.map((guide) => {
          const Icon = iconMap[guide.category] || Bot;

          return (
            <Card
              key={guide.id}
              onClick={() => navigate(guide.link)}
              className="flex flex-col justify-between border-gray-200 hover:border-blue-400 hover:shadow-md transition-all duration-200 group bg-white cursor-pointer"
            >
              <CardHeader className="space-y-3 pb-3">
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors duration-200">
                    <Icon size={20} />
                  </div>
                  <Badge variant="secondary" className="text-[11px] font-normal text-gray-600 bg-gray-100">
                    {guide.tag}
                  </Badge>
                </div>
                <CardTitle className="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {guide.title}
                </CardTitle>
                <CardDescription className="text-xs text-gray-500 leading-relaxed line-clamp-3">
                  {guide.description}
                </CardDescription>
              </CardHeader>

              <CardFooter className="pt-0">
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-between text-xs font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50/60 group-hover:bg-blue-50/40 p-2 h-8"
                  onClick={() => navigate(guide.link)}
                >
                  <span>{guide.actionLabel}</span>
                  <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
                </Button>
              </CardFooter>
            </Card>
          );
        })}
      </div>
    </section>
  );
};

export default QuickGuides;
